import { __awaiter } from "tslib";
import Vue from 'vue';
import layouts from '@/layouts/index.vue';
import { mapGetters } from 'vuex';
import moment from 'moment';
import Cookies from 'js-cookie';
import { nanoid } from 'nanoid';
export default Vue.extend({
    name: 'App',
    components: {
        layouts
    },
    mounted() {
        const vm = this;
        const setTime = () => {
            vm.$store.commit('dateTimeModule/setNowDateTime');
        };
        setInterval(setTime, 15000);
        if (this.getUserData.permissions.screener.available) {
            this.stakanMetrika();
        }
    },
    beforeCreate() {
        const setTrueVH = () => {
            const trueVH = window.innerHeight / 100;
            document.body.style.setProperty('--tVH', trueVH + 'px');
        };
        setTrueVH();
        window.addEventListener('resize', setTrueVH);
    },
    computed: Object.assign(Object.assign({}, mapGetters('user', ['getUserData', 'extendedKycStatus'])), mapGetters('popupModule', ['getFirstClosing'])),
    methods: {
        // kycCheck () {
        //   const vm = this as any
        //   if (this.extendedKycStatus !== 'accepted' && this.extendedKycStatus !== null) {
        //     const status = this.extendedKycStatus === 'wait' || this.extendedKycStatus === 'declined' ? this.extendedKycStatus : 'common'
        //     const titleMapString = vm.$t(`popups.titles.kycTitle${status}`)
        //     const contentMapString = vm.$t(`popups.content.kycContent${status}`)
        //     const btnTitle = vm.$t(`popups.content.kycBtn${status}`)
        //     vm.$store.dispatch('popupModule/openPopup', {
        //       type: ActivePopupTypes.action,
        //       letDefaultClose: false,
        //       title: titleMapString,
        //       content: contentMapString,
        //       slot: {},
        //       actions: [
        //         {
        //           title: btnTitle,
        //           isAccent: true,
        //           callback () {
        //             const url = getPassportUrl('/id/?verification-show=true', { withAcceptor: true })
        //             window.location.href = String(url)
        //           }
        //         }
        //       ]
        //     })
        //   }
        // },
        stakanMetrika() {
            const oldSessionID = Cookies.get('stakanSessionID');
            if (oldSessionID === undefined) {
                const newID = nanoid();
                Cookies.set('stakanSessionID', newID, { expires: moment().add(30, 'minutes').toDate() });
                window.ym(96934969, 'reachGoal', 'visit', { sessionId: newID, userId: this.getUserData.pk });
                window.ym(96934935, 'reachGoal', 'visit', { sessionId: newID, userId: this.getUserData.pk });
            }
            else {
                Cookies.set('stakanSessionID', oldSessionID, { expires: moment().add(30, 'minutes').toDate() });
            }
        }
    },
    created() {
        return __awaiter(this, void 0, void 0, function* () {
            localStorage.removeItem('withdrawSSID');
            localStorage.removeItem('transferPreset');
            const vm = this;
            vm.$store.dispatch('mainPageModules/loadFeatureFlags');
        });
    },
    watch: {
        extendedKycStatus() {
            // setTimeout(() => {
            //   this.kycCheck()
            // }, 1000)
        },
        getFirstClosing() {
            if (!window.location.pathname.includes('gateway')) {
                this.$store.dispatch('notifications/loadAll');
            }
        },
        'getUserData.permissions.screener.available'(available) {
            if (available) {
                this.stakanMetrika();
            }
        }
    }
});
